import React from 'react';
import {
  Box,
  Option,
  OptionKey,
  SelectDropdown,
  Text,
} from '@common-fe/common-fe';

interface SpendLimitsPeriodHeaderProps {
  title: string;
  showPeriodDropdown?: boolean;
  periodOptions: Option[];
  selectedPeriod?: OptionKey;
  onPeriodChange?: (value: OptionKey) => void;
  isPeriodLoading?: boolean;
  testIdPrefix: string;
}

export const SpendLimitsPeriodHeader: React.FC<SpendLimitsPeriodHeaderProps> = ({
  title,
  showPeriodDropdown,
  periodOptions,
  selectedPeriod,
  onPeriodChange,
  isPeriodLoading,
  testIdPrefix,
}) => {
  return (
    <Box margin={{ bottom: 'spacing24' }} direction="row" align="center" justify="between">
      <Box>
        <Text weight="bold" color="textTitle" size="large" style={{ whiteSpace: 'nowrap' }}>
          {title}
        </Text>
      </Box>
      {showPeriodDropdown && (
        <Box width="230px" margin={{ left: 'spacing8' }}>
          <SelectDropdown
            id={`${testIdPrefix}Period`}
            testId={`${testIdPrefix}-period`}
            name={`${testIdPrefix}Period`}
            prefix="Spend period"
            isLoading={isPeriodLoading}
            singleMode
            activeTitle
            options={periodOptions}
            value={selectedPeriod}
            onChange={onPeriodChange}
          />
        </Box>
      )}
    </Box>
  );
};
